import React, { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import AttachmentItem from '../AttachmentItem';
import ActionConfirmation from '../../../common/ActionConfirmation';
import { PATIENT_ATTACHMENTS_TYPE } from '../../../../constants/index';
import { selectUserAttachmentsList } from '../../../../redux/profiles/selectors';

import { actions as getUserAttachments } from '../../../../redux/profiles/get-user-attachment';
import { actions as deleteUserAttachment } from '../../../../redux/profiles/delete-user-attachment';
import { actions as deleteUserOutcomeAttachment } from '../../../../redux/profiles/delete-user-outcome-attachment';

import styles from './index.styl';

const { DOCUMENTS, OUTCOME_ATTACHMENTS } = PATIENT_ATTACHMENTS_TYPE;

const deleteActions = {
  [DOCUMENTS]: deleteUserAttachment,
  [OUTCOME_ATTACHMENTS]: deleteUserOutcomeAttachment,
};

const ProfileDocumentation = ({ userId, formatMessage }) => {
  const dispatch = useDispatch();

  const [openModal, toggleOpenModal] = useState(false);
  const [targetDocumentData, setTargetDocumentData] = useState(null);

  const attachments = useSelector(selectUserAttachmentsList);
  const hasAttachments = Boolean(attachments.length);

  const openActionConfirmationModal = data => {
    setTargetDocumentData(data);
    toggleOpenModal(true);
  };

  const getAttachments = () => dispatch(getUserAttachments.send({ userId }));

  const clearAttachments = () => dispatch(getUserAttachments.clear());

  const deleteAttachment = () => {
    const { id, uniqId, type } = targetDocumentData || {};

    const deleteAction = deleteActions[type];

    dispatch(
      deleteAction.send({
        id,
        type,
        uniqId,
        userId,
      }),
    );
  };

  useEffect(() => {
    getAttachments();
    return () => clearAttachments();
  }, []);

  return (
    <div className={styles.wrapper}>
      <span className={styles.sectionTitle}>
        {formatMessage({ id: 'documentation.attached.title' })}
      </span>
      {!hasAttachments && <div>-</div>}

      {hasAttachments &&
        attachments.map(file => (
          <AttachmentItem
            data={file}
            key={file.id}
            onDelete={openActionConfirmationModal}
          />
        ))}

      <ActionConfirmation
        width="xsmall"
        opened={openModal}
        mobileFullScreen={false}
        onSubmit={deleteAttachment}
        onClose={() => toggleOpenModal(false)}
        actionButtonText={formatMessage({
          id: 'common.delete',
        })}
        title={formatMessage({
          id: 'appointment.documents.deleteMessage',
        })}
      />
    </div>
  );
};

ProfileDocumentation.propTypes = {
  userId: PropTypes.number,
  formatMessage: PropTypes.func,
};

export default memo(ProfileDocumentation);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProfileDocumentation/Attachments/index.jsx